var default_styles_default = {
  "button_container": "aDdn-",
  "button_text": "T0FQI",
  "button_size_content": "Cg9h-"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
